import React, { PropTypes } from 'react'
import classnames from 'classnames'
import { colourFromString } from 'utils/colours'

import styles from './Avatar.scss'

// TODO: add icon option

const Avatar = ({
  className, group, size, title,
}) => {
  const classes = classnames(
    styles.base,
    styles[size],
    { [styles.group]: group },
    styles[colourFromString(title)],
    className,
  )

  // const character = title ? title[0].toUpperCase() : '?'
  const character = title ? title.toUpperCase() : '?'

  return (
    <div className={classes}>
      <span className={styles.letter}>{character}</span>
    </div>
  )
}

Avatar.propTypes = {
  className: PropTypes.string,
  group: PropTypes.bool,
  size: PropTypes.oneOf(['joel', 'small', 'medium', 'large', 'mega', 'massive']),
  title: PropTypes.string,
}

Avatar.defaultProps = {
  size: 'small',
  title: '?',
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/Avatar/Avatar.js